/** Client-side branch context — JWT is identity-only after roles governance. */

export const CURRENT_BRANCH_STORAGE_KEY = "stream_current_branch";

export function readStoredCurrentBranch(): string | null {
  try {
    return localStorage.getItem(CURRENT_BRANCH_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeStoredCurrentBranch(branchId: string | null): void {
  try {
    if (!branchId) {
      localStorage.removeItem(CURRENT_BRANCH_STORAGE_KEY);
      return;
    }
    localStorage.setItem(CURRENT_BRANCH_STORAGE_KEY, branchId);
  } catch {
    // ignore quota / private mode
  }
}

/** by_branch lists every org branch; unreachable ones carry no permissions. */
export function reachableBranchIds(
  byBranch: Record<string, string[]> | undefined | null
): string[] {
  return Object.entries(byBranch ?? {})
    .filter(([, permissions]) => permissions?.length > 0)
    .map(([id]) => id);
}
